import { render, staticRenderFns } from "./PointagesProjets.vue?vue&type=template&id=bd97be92&scoped=true&"
import script from "./PointagesProjets.vue?vue&type=script&lang=js&"
export * from "./PointagesProjets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd97be92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
